export default {
  login: '登录',
  register: '注册',
  forgotPassword: '找回密码',
  resetPassword: '重置密码',
  home: '首页',
  accountManage: '账号管理',
  personalCenter: '个人中心',
  messageNotifications: '消息通知',
  todoTasks: '事项待办',
  roleManage: '角色管理',
  permissionManage: '权限管理',
  companyManage: '公司管理',
  userList: '用户列表',
  userDetail: '用户详情',
  userVerificationConfig: '用户认证配置',
  userVerificationReviews: '认证审核记录',
  helpManage: '帮助管理',
  helpCreate: '新增帮助',
  helpEdit: '编辑帮助',
  helpCenter: '帮助中心',
  memberPlan: '会员套餐',
  memberDataOverview: '会员数据概览',
  memberPlanDetail: '会员详情',
  rechargePackages: '充值套餐',
  rechargeMyPacks: '我的套餐',
  rechargeRecords: '充值记录',
  adminRechargeRecords: '充值记录',
  adminRechargeOverview: '充值数据概览',
  rechargeResourceManage: '充值套餐管理',
  memberPlanOrders: '套餐购买记录',
  cloudSpace: '半度云空间',
  adminCloudSpace: '全平台存储管理',
  companyPlanManage: '会员套餐管理',
  companyPlanOrders: '开通记录',
  resourceGrantManage: '资源授权',
  eventManage: '活动管理',
  lotteryManage: '巨屏抽奖',
  eventCreate: '新建活动',
  eventEdit: '编辑活动',
  eventLocation: '地点设置',
  eventRegistration: '报名设置',
  eventRegistrationSetup: '报名配置',
  eventShareTemplate: '活动分享模板',
  eventSchedule: '会议日程',
  eventSeating: '座位编辑',
  eventSeatConfig: '座位配置',
  eventSeatArrangement: '座位编排',
  eventSeatQueryEditor: '座位查询页',
  eventCheckin: '签到管理',
  eventCheckinConfig: '签到配置',
  eventLotteryScreen: '巨屏抽奖',
  lotteryJoinH5: '扫码参与抽奖',
  lotteryWinnerQueryH5: '查询中奖情况',
  lotteryScreenH5: '巨屏抽奖现场',
  eventTaskManagement: '任务管理',
  eventSmsNotifications: '短信通知',
  votingManage: '投票管理',
  registrationManage: '问卷管理',
  registrationFormEdit: '问卷设计',
  registrationProxyEntry: '对接录入',
  proxyRegistrationList: '对接代填',
  proxyOrders: '对接订单',
  proxyGrantConsume: '对接人登录',
  proxyGrantLanding: '对接人登录',
  proxyBridge: '对接人登录',
  proxyEntryHint: '对接录入说明',
  registrationH5: '活动报名',
  participantLogin: '参会登录',
  participantRegister: '参会注册',
  participantEmailVerify: '邮箱验证',
  hotelManage: '酒店管理',
  seatLayoutList: '座位场地布置',
  seatLayoutEditor: '编辑座位场地',
  seatUsageRecords: '使用记录',
  seatUsageDetail: '查看座位安排',
  eventMicrosite: '活动装修',
  eventMicrositeEditor: '页面装修',
  micrositeH5: '活动微站',
  micrositeAgendaH5: '会议日程',
  seatQueryH5: '座位查询',
  checkinH5: '活动签到',
  checkinScanDeskH5: '扫码工作台',
  checkinPrintDeskH5: '签到打印',
  invitedIntro: '活动官网',
  invitedAgenda: '会议议程',
  invitedRegistration: '参与报名',
  invitedRecords: '报名记录',
  invitedOrders: '订单明细',
  albumCreate: '新建相册',
  albumEdit: '编辑相册',
  photoManage: '图片管理',
  aiRetouch: 'AI修图',
  baseInfo: '基础信息区',
  privacySettings: '隐私设置',
  shareSettings: '分享设置',
  topPromotion: '顶部宣传位',
  launchPoster: '启动页海报',
  loadingImage: '加载图',
  basicAd: '基础广告',
  bottomPromotionBar: '底部推广栏',
  batchWatermark: '批量水印',
  sideAd: '侧边广告',
  infoCard: '信息卡片',
  largeImageDetail: '大图详情页',
  photographerWorkbench: '摄影师工作台',
  retouchWorkbench: '修图师工作台',
  qcWorkbench: '品控师工作台',
  auditorWorkbench: '审核员工作台',
  workArea: '当前工作区域',
  defaultWorkflow: '默认工作流',
  albumImages: '相册图片',
  forbidden: '无访问权限',
  sxaDemands: '供需管理'
}
